import { api } from '../configs/axiosConfigs';

export const resetTableColumns = async (tableSettingsId: string) => {
  return await api.put(`/table_settings/${tableSettingsId}/reset.json`);
};
